import { Observable, catchError, tap, throwError } from 'rxjs';
import { CreateUserDTO, FilterDTO, SortDirection, UpdateUserInfoDTO, UserAccountClient, UserInfoDTO } from '../models/models.swagger.generated';
import { ToastService } from '../services/toast.service';
import { SpinnerService } from '../spinner/spinner.service';
import { ErrorType } from 'src/app/core/routing/error-types';
import { PagedQueryModel } from '../shared/table/paged-query-model';
import { IPagedItems } from 'src/app/base/shared/table/paged-items.interface';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UserManagementService {
  constructor(
    private toastService: ToastService,
    private spinnerService: SpinnerService,
    private userAccountClient: UserAccountClient
  ) { }

  getData(pagedQuery: PagedQueryModel): Observable<IPagedItems> {
    this.spinnerService.showSpinner = true;
    return this.userAccountClient.searchUsers(pagedQuery.filters, null, pagedQuery.skip, pagedQuery.take, pagedQuery.sortBy, pagedQuery.sortDirection)
      .pipe(
        tap(() => {
          this.spinnerService.showSpinner = false;
        }),
        catchError((error: any) => {
          this.spinnerService.showSpinner = false;
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        })
      );
  }

  public addRecord(data: CreateUserDTO): Observable<UserInfoDTO> {
    this.spinnerService.showSpinner = true;
    return this.userAccountClient.addUser(data)
      .pipe(
        tap(() => {
          this.spinnerService.showSpinner = false;
          this.toastService.showSuccess('i18n.base.user-management.messages.add-title', 'i18n.base.user-management.messages.add-success-message');
        }),
        catchError((error: any) => {
          this.spinnerService.showSpinner = false;
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        })
      );
  }

  public updateRecord(data: UpdateUserInfoDTO): Observable<UserInfoDTO> {
    this.spinnerService.showSpinner = true;
    return this.userAccountClient.updateUser(data)
      .pipe(
        tap(() => {
          this.spinnerService.showSpinner = false;
          this.toastService.showSuccess('i18n.base.user-management.messages.update-title', 'i18n.base.user-management.messages.update-success-message');
        }),
        catchError((error: any) => {
          this.spinnerService.showSpinner = false;
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        })
      );
  }
 
}

 
